module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }), _c('a', {
    attrs: {
      "id": "ing"
    }
  }), _vm._v("Basic Ingredients")]), _vm._v(" "), _c('p', {
    staticClass: "text_noindent"
  }, [_vm._v("The following ingredients are the building blocks for creating energy balls that are nutrient-rich, hold together well, and have a nice chewy texture.")]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "id": "pg8lev1"
    }
  }), _vm._v("Almonds")]), _vm._v(" "), _c('p', {
    staticClass: "first1_noindent"
  }, [_vm._v("Almonds are rich in magnesium, calcium, and iron, and are a source of healthy unsaturated fats. They create texture, add bulk, and, thanks to the healthy fats they contain, make you feel full.")]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "f0008-01"
    }
  }), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0008-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Almonds")]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "id": "pg8lev2"
    }
  }), _vm._v("Almond Butter")]), _vm._v(" "), _c('p', {
    staticClass: "first1_noindent"
  }, [_vm._v("This rich, velvety paste has all the benefits of almonds and adds moisture and richness. Choose a natural butter that contains only almonds to avoid the sugars and oils added to some butters.")]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "id": "pg8lev3"
    }
  }), _vm._v("Almond Flour or Meal (Ground Almonds)")]), _vm._v(" "), _c('p', {
    staticClass: "first1_noindent"
  }, [_vm._v("Use almond flour in energy balls for a softer, chewier consistency. It adds bulk and healthy fats, and blends well with dried fruit.")]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "id": "pg8lev4"
    }
  }), _vm._v("Almond Milk")]), _vm._v(" "), _c('p', {
    staticClass: "first1_noindent"
  }, [_vm._v("Almond milk adds moisture to energy balls and helps to bind the ingredients together. Always buy unsweetened almond milk. If you do not like almond milk, or need to avoid it, substitute another nondairy milk, such as oat, soy, rice, flax, hemp, or coconut milk.")]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "id": "pg8lev5"
    }
  }), _vm._v("Brown Rice Syrup")]), _vm._v(" "), _c('p', {
    staticClass: "first1_noindent"
  }, [_vm._v("This unrefined sweetener is a great alternative to regular sugars. A great vegan alternative to honey, it is a source of manganese, iron, potassium, and magnesium.")]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "id": "pg8lev6"
    }
  }), _vm._v("Cacao Powder (Raw) and Cocoa Powder")]), _vm._v(" "), _c('p', {
    staticClass: "first1_noindent"
  }, [_vm._v("Raw cacao powder is made from cacao beans. The fat is removed through a process that keeps the nutrients intact. Cocoa powder is produced from roasted cacao beans and may have lost some "), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }), _vm._v("nutrients. You can substitute cocoa powder for raw cacao powder. Both contain magnesium, iron, calcium, and vitamin B"), _c('sub', [_vm._v("6")]), _vm._v(".")]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "id": "pg9lev1"
    }
  }), _vm._v("Cashews")]), _vm._v(" "), _c('p', {
    staticClass: "first1_noindent"
  }, [_vm._v("Raw cashews contain healthy unsaturated fats, protein, and carbohydrates and are a source of magnesium, iron, and vitamin B"), _c('sub', [_vm._v("6")]), _vm._v(". In energy balls, they create a crunchy texture and add bulk.")]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "f0009-01"
    }
  }), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0009-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Cashews")]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "id": "pg9lev2"
    }
  }), _vm._v("Coconut")]), _vm._v(" "), _c('p', {
    staticClass: "first1_noindent"
  }, [_vm._v("Shredded unsweetened coconut is rich in fats and fiber, and adds bulk and flavor. Unlike dried or desiccated coconut, it increases the moisture content of energy balls. It contains vitamins C and E, B vitamins, iron, selenium, calcium, magnesium, and phosphorus.")]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "id": "pg9lev3"
    }
  }), _vm._v("Coconut Flour")]), _vm._v(" "), _c('p', {
    staticClass: "first1_noindent"
  }, [_vm._v("Coconut flour contains all the nutrients and benefits of shredded coconut, but three times the fiber and about one-quarter of the fat. In an energy ball, it soaks up moisture and creates a light, fluffy, cakelike consistency. Look for products without any additives.")]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "id": "pg9lev4"
    }
  }), _vm._v("Coconut Nectar")]), _vm._v(" "), _c('p', {
    staticClass: "first1_noindent"
  }, [_vm._v("An alternative to sugar, coconut nectar is made from the sap of coconut palm tree flowers. It is low glycemic and releases slowly into the bloodstream. Alternatively, you can use agave nectar, which is derived from the sap of the agave plant. This sweetener is controversial as it is said to contain excessive amounts of fructose, which can negatively affect blood-sugar levels. While agave nectar may not be ideal, in my opinion it is superior to refined sugar. Use honey in place of coconut or agave nectar for a nonvegan option.")]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "f0009-02"
    }
  }), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0009-02.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Cocoa powder")]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "id": "pg9lev5"
    }
  }), _vm._v("Coconut Palm Sugar")]), _vm._v(" "), _c('p', {
    staticClass: "first1_noindent"
  }, [_vm._v("When compared to refined sugars, coconut palm sugar is low on the glycemic index, meaning it releases more slowly into the bloodstream. It contains trace amounts of vitamin C, potassium, phosphorous, magnesium, calcium, zinc, iron, and copper, which makes it nutritionally superior to refined granulated sugars.")]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "id": "pg10lev1"
    }
  }), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }), _vm._v("Dark Chocolate")]), _vm._v(" "), _c('p', {
    staticClass: "first1_noindent"
  }, [_vm._v("While cocoa and cacao powder bring a chocolate flavor to energy balls, sometimes you need the real thing. Dark chocolate is rich in antioxidants, has the same nutritional benefits as cocoa and cacao powder, and varieties that contain at least 70 percent cacao have a reduced sugar content and higher overall nutritional value. To check that a chocolate is suitable for a vegan diet, make sure it does not contain modified milk or dairy products.")]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "id": "pg10lev2"
    }
  }), _vm._v("Dates")]), _vm._v(" "), _c('p', {
    staticClass: "first1_noindent"
  }, [_vm._v("Pitted dates are naturally sweet and have a low glycemic load, meaning that they don’t cause a spike in blood-sugar levels. Dates are a source of magnesium, calcium, iron, phosphorus, potassium, zinc, vitamins A and K, and several B vitamins. They work best when they are soft and moist. If your dates have dried out, soak them in hot water for 10 to 15 minutes, then drain before use.")]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "id": "pg10lev3"
    }
  }), _vm._v("Maple Syrup, Pure")]), _vm._v(" "), _c('p', {
    staticClass: "first1_noindent"
  }, [_vm._v("This ingredient is near and dear to my heart, as it is of Canadian origin. Pure maple syrup contains manganese, zinc, calcium, iron, potassium, and magnesium, and, as a natural sweetener, it releases more slowly into the bloodstream than sugar, preventing blood sugar spikes. It is found in two grades: Grade A, Amber Color and Rich Flavor and Grade A, Dark Color and Robust Flavor. I suggest the Grade A Amber for its rich taste with balanced medium levels in flavor and color. Do not use imitation maple syrups.")]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "f0010-01"
    }
  }), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0010-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Maple syrup")]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "id": "pg10lev4"
    }
  }), _vm._v("Oats, Gluten-Free Rolled")]), _vm._v(" "), _c('p', {
    staticClass: "first1_noindent"
  }, [_vm._v("These rolled seeds are bursting with B vitamins, iron, magnesium, fiber, and slow-release complex carbohydrates. In some recipes they are replaced with quick oats, as those blend better to provide bulk without a grainy texture. Always use certified gluten-free plain, unsweetened oats.")]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "f0010-02"
    }
  }), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0010-02.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Oats")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2e2c72ac","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/07-basic.vue
// module id = 75
// module chunks = 0